/** Sök bland funktionskort på en systemsida. Tom sökning visar alla. */
export function moduleMatchesQuery(title: string, description: string, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return `${title} ${description}`.toLowerCase().includes(needle);
}

/** Snabb bokning visas bara när modulen finns. Vanlig bokning kräver kalendern. */
export function bookingCreateActions(moduleNames: readonly string[]): { quick: boolean; regular: boolean } {
  const names = new Set(moduleNames);
  return {
    quick: names.has('quick-booking'),
    regular: names.has('calendar'),
  };
}
